import { vizColors, vizColorValueOrder } from '@opengov/capital-style';
import { IColorVariants } from '@opengov/components-visualization';
import { OG_TARGET_CATEGORY } from '@opengov/reporting-transforms/visualizations';
import { IReportTarget } from '@opengov/reporting-types';

const getColorVariant = (hue: keyof typeof vizColors) => {
  const value = vizColorValueOrder[vizColors[hue].data][0];
  const baseColor = vizColors[hue][value];
  const hoverColor = vizColors[hue][value + 100];
  const highlightColor = vizColors[hue][vizColors[hue].highlight];
  return { base: baseColor, hover: hoverColor, line: baseColor, highlight: highlightColor };
};

export const targetColorMap = (target: IReportTarget): { [key: string]: IColorVariants } => {
  const colors = {};
  const firstCondition = target.conditions[0];
  if (firstCondition) colors[firstCondition.status.text] = getColorVariant('jade');
  const secondCondition = target.conditions[1];
  if (secondCondition) colors[secondCondition.status.text] = getColorVariant('orange');
  if (target.elseStatus) colors[target.elseStatus.text] = getColorVariant('red');
  (colors as any)[OG_TARGET_CATEGORY] = { base: '#B5B9BD', hover: '#B5B9BD', line: '#B5B9BD', highlight: '#B5B9BD' };

  return colors;
};
